import { render, staticRenderFns } from "./user_table.vue?vue&type=template&id=5983ea1f&scoped=true"
import script from "./user_table.vue?vue&type=script&lang=js"
export * from "./user_table.vue?vue&type=script&lang=js"
import style0 from "./user_table.vue?vue&type=style&index=0&id=5983ea1f&prod&lang=css"
import style1 from "./user_table.vue?vue&type=style&index=1&id=5983ea1f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5983ea1f",
  null
  
)

export default component.exports